var freeGiftCheck = 0;
window.loadedfreeGift = setInterval(function () {
  if (window.jQuery !== undefined && window.Shopify !== undefined) {
    window.freeGift = {
      selectors: {
        cartItems: ".js-cart-item",
        cartSubtotal: ".subtotal_price",
        collectionGrid: ".fg_upsell",
        couponInput: "input#discount",
      },

      // Precalculated tiers
      tiers: [200, 300, 500, 750, 1000, 1500, 2500, 5000],

      /**
       * @summary Initializes the free gift functionality
       *
       * @description Adds event listeners and performs
       * the first dom update.
       *
       * @return  {void}
       */
      init: function () {
        var self = this;

        self.addEventListeners();
        self.update();
      },

      /**
       * @summary Adds event listeners
       *
       * @description Creates the event listeners
       * used throughout this class.
       *
       * @return  {void}
       */
      addEventListeners: function () {
        var self = this;
        var cartUrls = [
          "/cart/add.js",
          "/cart/update.js",
          "/cart/change.js",
          "/cart/clear.js",
        ];

        // Listen for cart updates
        $(document).ajaxComplete(function (e, jqxhr, settings) {
          cartUrls.includes(settings.url) ? self.update() : null;
        });
      },

      /**
       * @summary Responsible for all DOM related actions
       *
       * @description Updates (or initializes if called
       * for the first time) the DOM.
       *
       * @return  {void}
       */
      update: function () {
        var self = this;

        // Show loading
        $(self.selectors.collectionGrid).length
          ? $(self.selectors.collectionGrid).addClass("loading")
          : null;

        // Show loading for products
        $(".free-gift-show").each(function (i, el) {
          $(el).addClass("loading");
        });

        // Get the cart first.
        self.getCart(function (cart) {
          let price = 0;

          cart.items?.map((item) => {
            if (item.product_type !== "Free Gifts") {
              price = price + item.price * item.quantity;
            }
          });

          var tier = self.getTier(price);

          // We need an update, tier has changed.
          if (self.currentTier == false || self.currentTier !== tier) {
            self.getCollection(tier, 1, [], function (products) {
            // // ELEVAR START=====================================
            //   window.productsBreadcrumbs = window.productsBreadcrumbs || [];
            //   products.forEach((product) => {
            //     // Create product data from collection product details
            //     const productData = {
            //       product_id: product.id.toString(),
            //       name: product.title,
            //       brand: product.vendor,
            //       image: product.images[0]?.src || "https://via.placeholder.com/300",
            //       list: `/products/${product.handle}`,
            //       price: product.variants[0]?.price.toString() || "0",
            //       currencyCode: Shopify.currency.active,
            //       quantity: "1",
            //       url: `https://gemplers.com/products/${product.handle}`,
            //       variant: product.variants[0]?.title || "Default Variant",
            //       variant_id: product.variants[0]?.id.toString() || "0",
            //       item_category1: "Free Gifts"
            //     };
            //     if (!window.productsBreadcrumbs.some(p => p.product_id === productData.product_id)) {
            //       window.productsBreadcrumbs.push(productData);
            //     }
            //   });
            // // ELEVAR END=======================================

              // ELEVAR START=====================================
              window.productsBreadcrumbs = window.productsBreadcrumbs || JSON.parse(localStorage.getItem('productsBreadcrumbs')) || [];
              products.forEach((product) => {
                const productData = {
                  product_id: product.id.toString(),
                  name: product.title,
                  brand: product.vendor,
                  image: product.images[0]?.src || "https://via.placeholder.com/300",
                  list: `/products/${product.handle}`,
                  price: product.variants[0]?.price.toString() || "0",
                  currencyCode: Shopify.currency.active,
                  quantity: "1",
                  url: `https://gemplers.com/products/${product.handle}`,
                  variant: product.variants[0]?.title || "Default Variant",
                  variant_id: product.variants[0]?.id.toString() || "0",
                  item_category1: "Free Gifts"
                };
                if (!window.productsBreadcrumbs.some(p => p.product_id === productData.product_id)) {
                  window.productsBreadcrumbs.push(productData);
                }
              });
              // Store the productsBreadcrumbs in localStorage
              localStorage.setItem('productsBreadcrumbs', JSON.stringify(window.productsBreadcrumbs));
              // ELEVAR END=======================================
              
                            
              self.setCoupon(tier, cart, products);
              self.buildSlider(tier, cart, products);
              self.updateSubtotal();

              $("[data-tier]").each(function (i, el) {
                $(el).removeClass("loading");
              });
            });
          }
        });
      },

      /**
       * @summary Gets products in a collection
       *
       * @description Loops through all pages in a collection
       * json response and pools them together
       *
       * @param   {int}       tier The tier value
       * @param   {int}       page The page to loop
       * @param   {array}     total Set this to an empty array on init
       * @param   {function}  callback The callback function
       *
       * @return  {void}
       */
      getCollection: function (tier, page, total, callback) {
        var self = this;

        // Default values
        total === undefined ? (total = []) : null;
        tier === 0 ? (tier = 100) : tier;

        $.getJSON(
          `/collections/free-gifts-${tier}/products.json?page=${page}`,
          function (res) {
            res.hasOwnProperty("products") && res.products.length > 0
              ? (page++,
                self.getCollection(
                  tier,
                  page,
                  res.products.concat(total),
                  callback
                ))
              : callback(total);
          }
        );
      },

      /**
       * @summary Sets the appropriate coupon value
       *
       * @description Determines which tier we are on
       * then sets the approperiate coupon we need. In order
       * to avoid adding a non qualifying coupong during
       * checkout we only set the highest level coupon
       * available for the products in the cart.
       *
       * @param   {int} tier The current tier
       *
       * @return  {void}
       */
      setCoupon: function (tier) {
        var self = this;
        var products = $("[data-tier]").sort(function (a, b) {
          return (
            parseInt($(b).data("tier")) - parseInt($(a).data("tier")) ||
            parseInt($(a).data("price")) - parseInt($(b).data("price"))
          );
        });

        products.each(function (i, el) {
          $(el)
            .removeClass("free-gift-show")
            .find(".line_item_price")
            .removeAttr("data-content");

          if ($(el).data("tier") <= tier) {
            $(self.selectors.couponInput).val(`FG${$(el).data("tier")}`);
            $(el)
              .addClass("free-gift-show")
              .find(".line_item_price")
              .attr("data-content", self.getDiscount($(el)));
            return false;
          }
        });
      },

      /**
       * @summary Updates subtotal
       *
       * @description Loops through free gift products
       * and determines how much to remove from subtotal.
       *
       * @return  {void}
       */
      updateSubtotal: function () {
        var self = this;
        var products = $(self.selectors.cartItems);
        var subTotal = $(self.selectors.cartSubtotal);
        var subTotalFloat = parseFloat(
          subTotal.text().replace(",", "").substr(1)
        );

        products.each(function (i, el) {
          if ($(el).hasClass("free-gift-show")) {
            subTotal.text(
              Shopify.formatMoney(
                `${(
                  subTotalFloat -
                  parseInt($(el).data("price")) / 100
                ).toFixed(2)}`
              )
            );
            return false;
          }
        });
      },

      /**
       * @summary Calculates product discount
       *
       * @description Calculates and returns the total
       * price for item based on quantity. To be used
       * in after/before pseudo elements.
       *
       * @param   {object} product The product el
       *
       * @return  {string}
       */
      getDiscount: function (product) {
        var price = parseInt(product.data("price")) / 100;
        var qty = product.find(".filter-option-inner-inner").length
          ? parseInt(product.find(".filter-option-inner-inner").text())
          : parseInt(product.find('[name="quantity"]').val());

        return Shopify.formatMoney(`${(qty * price - price).toFixed(2)}`);
      },

      /**
       * @summary Get the tier
       *
       * @description Returns the tier which the current
       * cart total falls under. Without consideration for
       * current products.
       *
       * @param   {int} total The total being evaluated
       *
       * @return  {int}
       */
      getTier: function (total) {
        var self = this;
        var tier = 0;

        for (let i = 0; i < self.tiers.length; i++) {
          if ((total / 100).toFixed(2) >= self.tiers[i]) tier = self.tiers[i];
        }

        return tier;
      },

      /**
       * @summary Gets the cart contents
       *
       * @description Returns the cart and items in the cart
       *
       * @param   {function} callback The callback function
       *
       * @return  {object} The cart object
       */
      getCart: function (callback) {
        $.getJSON("/cart.js", function (cart) {
          callback(cart);
        });
      },

      /**
       * @summary Build the slider to be used for below
       * the cart.
       *
       * @description Parses the products and builds the slider
       * html that's used to display the appropriate free gift
       * products.
       *
       * @param   {int}     tier The current tier
       * @param   {object}  cart The current cart
       * @param   {array}   products Free gift collection products
       *
       * @return  {voic}
       */
      buildSlider: function (tier, cart, products) {
        var self = this;
        var maxTier = self.tiers.lastIndexOf(tier) + 1 === self.tiers.length;
        var nextTier = maxTier ? tier : self.tiers.indexOf(tier) + 1;

        $(self.selectors.collectionGrid).html(
          `<div class="free-gift-wrapper ${tier > 0 ? "" : "disabled"}">
            <div class="free-gift-content">

              <div class="free-gift-header">
                <h3 class="free-gift-title">${
                  tier > 0
                    ? `You qualify for a free gift promotion!`
                    : `You are ${Shopify.formatMoney(
                        (self.tiers[0] - cart.total_price / 100).toFixed(2)
                      )} away from a free gift! <a href="/collections/all">Continue shopping</a>`
                }
                </h3>
              </div>
              
              <div id="free-gift-collapse">
                ${
                  tier > 0 && tier !== undefined
                    ? maxTier
                      ? `<span class="free-gift-subhead">You've reached the top free gift tier.</span>`
                      : `<span class="free-gift-subhead">Spend an additional ${Shopify.formatMoney(
                          (
                            self.tiers[nextTier] -
                            cart.total_price / 100
                          ).toFixed(2)
                        )} to reach the next free gift tier.</span>`
                    : ``
                }
                <p class="free-gift-description">${
                  tier > 0
                    ? `Choose from the items below and apply code at checkout, or spend more and <a href="/pages/free-gifts">see additional tiers</a>. Cannot be combined with other offers, discounts, or promotions.`
                    : `Add more items to your cart to be eligible for the products below and <a href="/pages/free-gifts">unlock additional tiers</a> the more you spend.`
                }
                </p>
                
                <div class="free-gift-slider">
                  ${products
                    .map((p) => {
                      return `
                      <div class="free-gift-slide">
                        <div class="free-gift-product">
                          <img class="img-fluid" src="${
                            p.images[0].src ?? "//placehold.it/300x300"
                          }" alt="${p.title}" />
                          <div>
                            <span class="title">${p.title}</span>
                            <span class="btn frgft-atc-button" data-product_id="${p.id}" data-quickview="${
                              p.handle
                            }">Add</span>
                          </div>
                        </div>
                      </div>
                    `;
                    })
                    .join("")}
                </div>
              </div>
            </div>
          </div>`
        );

        $(".free-gift-slider").slick({
          dots: false,
          infinite: true,
          arrows: true,
          autoplay: false, // only when eligible for free gift
          // autoplay      : tier > 0 ? true : false, // only when eligible for free gift
          // autoplaySpeed : 1750,
          slidesToShow: 2,
          variableWidth: true,
          centerMode: false,
        });

        // Remove any loading classes
        $(self.selectors.collectionGrid).removeClass("loading");
      },
    };

    // Initialize product options
    freeGift.init();
    clearInterval(window.loadedfreeGift);
  }

  if (freeGiftCheck >= 15)
    console.log("Error! - Could not load free gift."),
      clearInterval(window.loadedfreeGift);

  freeGiftCheck++;
}, 300);
